<template>
  <div id="invoice-table-container d-flex justify-content-center">
    <div class="text-center">
      <base-spinner v-if="loading" class="m-5 green-1" />
    </div>
    <base-table
      v-if="!loading"
      ref="base-table"
      :table_width="table_width"
      :rowClick="openModal"
      :multiSelect="false"
      :columns="$isMobile()? mobile_table_columns : table_columns"
      :havePagination="havePagination"
      :data="table_data"
      :tableActions="tableActions"
      :haveSort="true"
      defaultSortField="created_at"
      defaultSortType="date"
      :totalRows="totalRows"
      :activePage="activePage"
      :paginationNavFunction="paginationNavFunction"
      :rowHighlightFunction="rowHighlightCheck"
      receivableProperty="is_receivable"
      @column-sort="columnSort"
    />
    <!-- <detail-modal :data="modal_data" /> -->
  </div>
</template>

<script>

import { mapState } from "vuex";

import { INVOICE_STATES, RECEIVABLE } from "@/constants";
import {
  TableColumnBuilder,
  sortTypes,
} from "@/components/UI/classes/tableColumn";
import { ActionButton } from "@/components/UI/classes/actionButton"; 
import InvoicesService from "@/services/invoices.service";

import BaseTable from '@/components/UI/BaseTable.vue';
import BaseSpinner from "@/components/UI/BaseSpinner.vue";

// import DetailModal from "./DetailModal.vue";
// import InvoicesService from '@/services/invoices.service';

// eslint-disable-next-line no-unused-vars
export default {
  name: "invoice-table",
  props: {
    table_width: {
      required: false,
    },
    havePagination: {
      required: false,
    },
    invoices: {
      required:true
    },
    withTypeColumn: {
      default: false
    },
    minimalist: {
      default: false,
      type: Boolean
    },
    paginationNavFunction: {
      required: false,
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.invoice.loadingInvoices,
      totalRows: (state) => state.invoice.totalRows,
      activePage: (state) => state.invoice.activePage,
    }),
  },
  components: {
    BaseTable,
    BaseSpinner,
  },
  data() {
    return {

      modal_data: null,
      tableActions: [
        new ActionButton("View Details", null, "las la-eye la-lg text-muted", this.openModal),
        new ActionButton(
          "Copy URL", 
          null, 
          "las la-money-bill la-lg text-muted", 
          this.copyPaymentUrl,
          (invoice) => {
            return  (
              invoice 
              && invoice.seller_id === this.$store.getters.user.business_id 
              && invoice.status!==INVOICE_STATES.PAID 
              && invoice.status!==INVOICE_STATES.SETTLED
              && invoice.status!==INVOICE_STATES.DRAFT
              && invoice.status!==INVOICE_STATES.VOIDED 
            );
          }
        ),
        new ActionButton(
          "Edit Invoice",
          null,
          "las la-edit la-lg text-muted",
          (invoice) => {
            this.$router.push({
                name: "EditInvoice",
                params: {
                  invoice_id: invoice.id,
                },
            });
          },
          (invoice) => {
            return invoice.seller_id === this.$store.getters.user.business_id &&
              invoice.status !== INVOICE_STATES.PAID &&
              invoice.status !== INVOICE_STATES.COOLING &&
              invoice.status !== INVOICE_STATES.SETTLED &&
              invoice.status !== INVOICE_STATES.VOIDED;
          }
        ),
        new ActionButton(
          "Resend Email",
          null,
          'las la-paper-plane la-lg',
          (invoice) => {
            this.$store.state.open_menu_index = null;
            InvoicesService.sendEmail(invoice.id)
            .then(() => {
              this.$showAlert("Invoice sent", "success");
            })
            .catch(() => this.$showAlert("Failed to send invoice"));
          },
          (invoice) => {
            return (
              invoice && 
              invoice.seller_id === this.$store.state.auth.user.business_id && 
              invoice.status !== INVOICE_STATES.PAID &&
              invoice.status !== INVOICE_STATES.SETTLED
            );
          }
        ),
        new ActionButton(
          "Mark as settled",
          null,
          'las la-check-square la-lg',
          (invoice) => {
            InvoicesService.markAsSettled(invoice.id)
            .then(() => {
              this.$showAlert("Sucessfully marked", "success");
              this.$router.go();
            })
            .catch(() => this.$showAlert("Failed to mark"));
          },
          (invoice) => {
            return invoice && invoice.seller_id === this.$store.state.auth.user.business_id && invoice.status!==INVOICE_STATES.SETTLED && invoice.status!==INVOICE_STATES.VOIDED;
          }
        ),
        new ActionButton(
          "Undo Settled",
          null,
          'las la-undo la-lg',
          (invoice) => {
            InvoicesService.undoSettled(invoice.id)
            .then(() => {
              this.$showAlert("Undo Settled", "success");
              this.$router.go();
            })
            .catch(() => this.$showAlert("Failed to mark"));
          },
          (invoice) => {
            return invoice && invoice.seller_id === this.$store.state.auth.user.business_id && invoice.status == INVOICE_STATES.SETTLED;
          }
        ),
        new ActionButton(
          "Pay",
          null, 
          "las la-file-invoice-dollar la-lg text-muted", 
          (invoice) => {
            this.$router.push({
                name: "InvoiceDetails",
                params: {
                  invoice_id: invoice.id,
                },
              });
          },
          (invoice) => {
            return invoice.seller_id !== this.$store.getters.user.business_id && invoice.status !== "PAID";
          },
        ),
      ],
      table_data: [],
      table_columns: [
        new TableColumnBuilder()
        .addHeaderAndAccessor("INVOICE #", "reference_number")
        .addSorting("reference_number", sortTypes.TEXT)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("TYPE", "type")
        .addSorting("type", sortTypes.NUMERIC)
        .addRenderCondition(() => this.withTypeColumn),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("COMPANY", "company")
        .addSorting("company", sortTypes.TEXT)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("CONTACT", "contact")
        .addSorting("contact", sortTypes.TEXT)
        .addRenderCondition(() => !this.minimalist)
        .build(),

        new TableColumnBuilder()
        .addHeaderAndAccessor("ISSUE DATE", "issueDateFormatted")
        .addSorting("issue_date", sortTypes.DATE)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("DUE DATE", "dueDateFormatted")
        .addSorting("due_date", sortTypes.DATE)
        .build(),
       
        new TableColumnBuilder()
        .addHeaderAndAccessor("AMOUNT", "amountFormatted")
        .addSorting("amount", sortTypes.NUMERIC)
        .addColumnStyle("width: 80px; direction: rtl")
        .addHtml((amountFormatted) => amountFormatted)
        .addRenderCondition(() => !this.minimalist)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("DUE AMOUNT", "amountDueStyled")
        .addSorting("amount_due", sortTypes.NUMERIC)
        .addColumnStyle("width: 80px; direction: rtl")
        .addHtml((amountDueStyled) => amountDueStyled)
        .build(),

        new TableColumnBuilder()
        .addHeaderAndAccessor("CREATED", "created_styled")
        .addSorting("created_at", sortTypes.DATE)
        .addRenderCondition(() => !this.minimalist)
        .build(),
          
        new TableColumnBuilder()
        .addHeaderAndAccessor("STATUS", "status")
        .addSorting("status", sortTypes.TEXT)
        .addHtml((status) => {
          const state_class = {
            [INVOICE_STATES.PAID]: "paid-status",
            [INVOICE_STATES.OVERDUE]: "overdue-status",
            [INVOICE_STATES.SETTLED]: "settled-status",
            [INVOICE_STATES.DUE]: "due-status",
            [INVOICE_STATES.COOLING]: "cooling-status",
            [INVOICE_STATES.DRAFT]: "draft-status",
            [INVOICE_STATES.REJECTED]: "rejected-status",
            [INVOICE_STATES.VOIDED]: "void-status",
          };
          return `<div class="status ${
            state_class[status] || ""
          }">${status}</div>`;
        })
        .build(),
      ],
      mobile_table_columns: [
      new TableColumnBuilder()
        .addHeaderAndAccessor("INVOICE #", "reference_number")
        .addSorting("reference_number", sortTypes.TEXT)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("COMPANY", "company")
        .addSorting("company", sortTypes.TEXT)
        .build(),
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("ISSUE DATE", "issueDateFormatted")
        .addSorting("issue_date", sortTypes.DATE)
        .build(),

        new TableColumnBuilder()
        .addHeaderAndAccessor("DUE DATE", "dueDateFormatted")
        .addSorting("due_date", sortTypes.DATE)
        .build(),
       
        
        new TableColumnBuilder()
        .addHeaderAndAccessor("DUE AMOUNT", "amountDueStyled")
        .addSorting("amount_due", sortTypes.NUMERIC)
        .addColumnStyle("width: 80px; direction: rtl")
        .addHtml((amountDueStyled) => amountDueStyled)
        .build(),
          
        new TableColumnBuilder()
        .addHeaderAndAccessor("STATUS", "status")
        .addSorting("status", sortTypes.TEXT)
        .addHtml((status) => {
          const state_class = {
            [INVOICE_STATES.PAID]: "paid-status",
            [INVOICE_STATES.OVERDUE]: "overdue-status",
            [INVOICE_STATES.SETTLED]: "settled-status",
            [INVOICE_STATES.DUE]: "due-status",
            [INVOICE_STATES.COOLING]: "cooling-status",
            [INVOICE_STATES.DRAFT]: "draft-status",
            [INVOICE_STATES.REJECTED]: "rejected-status",
            [INVOICE_STATES.VOIDED]: "void-status",
          };
          return `<div class="status ${
            state_class[status] || ""
          }">${status}</div>`;
        })
        .addActions()
        .build(),
      ]
    };
  },
  watch: {
    invoices() {
      if (this.invoices !== null) {
        this.setTableData();
        return;
      }
      this.table_data = null;
      return;
    },
  },
  methods: {
    rowHighlightCheck(record) {
      return !record.is_read && !(this.$store.state.auth.user.business_id === record.seller_id);
    },
    openModal(data) {
      this.modal_data = data;
      this.$bvModal.show("pay-invoice-details-modal");
    },
    openDetails() {
      // this.$router.push({name: "InvoiceDetails", params: {invoice_id: data.id}});
      // this.$bvModal.show("pay-invoice-details");
    },
    copyPaymentUrl(data) {
      // let route = this.$router.resolve({name: "PayInvoice", params: { invoice_id: data.id }});
      // let absoluteURL = new URL(route.href, window.location.origin).href;
      navigator.clipboard.writeText(data.payment_url);
      this.$showAlert("Payment URL copied to clipboard", "info");
    },
    setTableData() {
      let data = [];
      if (this.invoices && this.invoices.length) {
        data =[...this.invoices].map((invoice) => {
          return {
            id: invoice.id,
            receipt: invoice.receipt,
            purchase_receipt: invoice.purchase_receipt,
            platform: invoice.platform,
            type: invoice.type,
            contact:
              invoice.type === RECEIVABLE
                ? (invoice.buyer_user && invoice.buyer_user.name) ||
                  invoice.buyer_user_name
                : (invoice.seller_user && invoice.seller_user.name) ||
                  invoice.seller_user_name,
            contact_email: 
              invoice.type === RECEIVABLE
                  ? (invoice.buyer_user && invoice.buyer_email) ||
                    invoice.buyer_email
                  : (invoice.seller_user && invoice.seller_user.email) ||
                    invoice.seller_user.email,
            reference_number: invoice.reference_number,
            kema_reference_id: invoice.kema_reference_id,
            seller_id: invoice.seller.id,
            buyer_id: invoice.buyer && invoice.buyer.id || "",
            company:
              invoice.type === RECEIVABLE
                ? (invoice.buyer && invoice.buyer.name) ||
                  invoice.buyer_name ||
                  ""
                : (invoice.seller && invoice.seller.name) ||
                  invoice.seller_name,
            summary: "Not Implemented",
            due_date: invoice.due_date,
            issue_date: invoice.issue_date,
            dueDateFormatted: this.$formatDate(invoice.due_date),
            issueDateFormatted: this.$formatDate(invoice.issue_date),
            created_at: invoice.created_at,
            created_styled: this.$formatDate(invoice.created_at),
            currency: invoice.currency,
            amount: invoice.amount,
            amount_due: invoice.amount_due,
            amountFormatted: this.$formatTableCurrency(
              invoice.amount,
              invoice.currency
            ),
            amountDueStyled: this.$formatTableCurrency(
              invoice.amount_due,
              invoice.currency
            ),
            account: invoice.account,
            status: invoice.status,
            createdAt: invoice.created_at,
            updatedAt: invoice.updated_at,

            payment_url: invoice.payment_url,
            is_read: invoice.is_read,

            displayPay:
              invoice.seller.id !== this.$store.getters.user.business_id &&
              invoice.status !== "PAID",
            displayEdit:
              invoice.seller.id === this.$store.getters.user.business_id &&
              invoice.status !== "PAID" &&
              invoice.status !== "COOLING",

            history: invoice.history
          };
        });
      } 
      this.table_data = data;
    },
    columnSort(columnValue){
      this.$emit("column-sort", columnValue);
    }
  },
};
</script>
